module.exports = {
    customer: 'driveplus',
    assets: { logo: 'logo.svg' }
    
};